import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What qualifications do your iOS developers possess?",
    answer: `<p>Our iOS developers are highly skilled professionals with extensive experience in Swift, Objective-C, and SwiftUI. They have a proven track record of delivering high-quality iOS applications and are proficient in using the latest development tools and technologies.</p>`,
  },
  {
    question: "How do you ensure the quality of the developers you provide?",
    answer: `<p>We have a rigorous vetting process that includes technical assessments, coding tests, and interviews. We only select developers who demonstrate exceptional technical skills, problem-solving abilities, and a strong understanding of iOS development best practices.</p>`,
  },
  {
    question: "Can I hire developers for short-term projects?",
    answer: `<p>Yes, you can hire our iOS developers for both short-term and long-term projects. We offer flexible hiring options to meet the unique needs of your business, whether you need a developer for a few weeks or several months.</p>`,
  },
  {
    question: "How do I communicate with the developers I hire?",
    answer: `<p>You can communicate with your hired developers through various channels, including email, chat, video calls, and project management tools like Slack, Trello, or Jira. We ensure seamless communication to keep you updated on the project's progress.</p>`,
  },
  {
    question: "What is your pricing model for hiring iOS developers?",
    answer: `<p>Our pricing model is flexible and competitive, based on the developer's experience level and the duration of the project. We offer transparent pricing with no hidden fees, and you can choose between hourly rates, fixed-price contracts, or retainer agreements.</p>`,
  },
  {
    question:
      "Do you provide ongoing support and maintenance after the project is completed?",
    answer: `<p>Yes, we offer ongoing support and maintenance services to ensure your app continues to run smoothly after launch. Our developers can assist with updates, bug fixes, and new feature development as needed.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Hire iOS Developers FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
